module.exports = __webpack_public_path__ + "static/media/print-tests.cdc8c1b4.svg";